import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

// Tinted like the rest of the dashboard: a token at 10 % behind the same token.
const TINTS = [
  "bg-brand/10 text-brand",
  "bg-info/10 text-info",
  "bg-success/10 text-success",
  "bg-warning/10 text-warning",
  "bg-destructive/10 text-destructive",
];

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase() || "?";
}

/** The same name always gets the same tint, so a client keeps its colour across widgets. */
function tintFor(name: string): string {
  let hash = 0;
  for (const char of name) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return TINTS[hash % TINTS.length] as string;
}

// Decorative: the name is always rendered next to it, so screen readers skip the initials
// (otherwise a row link reads "KP Kari Pettersen").
export function InitialsAvatar({ name }: { name: string }) {
  return (
    <Avatar className="h-8 w-8" aria-hidden="true">
      <AvatarFallback className={cn("text-xs font-semibold", tintFor(name))}>
        {initials(name)}
      </AvatarFallback>
    </Avatar>
  );
}
